export const SET_WIZARD_ACCOUNT_TYPE = 'SET_WIZARD_ACCOUNT_TYPE';
export const NEXT_WIZARD_STEP = 'NEXT_WIZARD_STEP';
export const PREV_WIZARD_STEP = 'PREV_WIZARD_STEP';
export const SET_WIZARD_STEP = 'SET_WIZARD_STEP';
//TODO: remove this logic
export const SET_WIZARD_COMPLETED_LAST_WIZARD_STEP =
  'SET_WIZARD_COMPLETED_LAST_WIZARD_STEP';
export const SET_WIZARD_USER = 'SET_WIZARD_USER';
export const SET_WALLET_API_ERRORS = 'SET_WALLET_API_ERRORS';

export const UPDATE_WIZARD_PRODUCER_REQUEST = 'UPDATE_WIZARD_PRODUCER_REQUEST';
export const UPDATE_WIZARD_PRODUCER_SUCCESS = 'UPDATE_WIZARD_PRODUCER_SUCCESS';
export const UPDATE_WIZARD_PRODUCER_FAIL = 'UPDATE_WIZARD_PRODUCER_FAIL';

export const FETCH_WIZARD_COMPANY_DETAIL_BY_EMAIL_REQUEST =
  'FETCH_WIZARD_COMPANY_DETAIL_BY_EMAIL_REQUEST';
export const FETCH_WIZARD_COMPANY_DETAIL_BY_EMAIL_SUCCESS =
  'FETCH_WIZARD_COMPANY_DETAIL_BY_EMAIL_SUCCESS';
export const FETCH_WIZARD_COMPANY_DETAIL_BY_EMAIL_FAIL =
  'FETCH_WIZARD_COMPANY_DETAIL_BY_EMAIL_FAIL';

export const CREATE_WIZARD_COMPANY_REQUEST = 'CREATE_WIZARD_COMPANY_REQUEST';
export const CREATE_WIZARD_COMPANY_SUCCESS = 'CREATE_WIZARD_COMPANY_SUCCESS';
export const CREATE_WIZARD_COMPANY_FAIL = 'CREATE_WIZARD_COMPANY_FAIL';

export const UPDATE_WIZARD_COMPANY_REQUEST = 'UPDATE_WIZARD_COMPANY_REQUEST';
export const UPDATE_WIZARD_COMPANY_SUCCESS = 'UPDATE_WIZARD_COMPANY_SUCCESS';
export const UPDATE_WIZARD_COMPANY_FAIL = 'UPDATE_WIZARD_COMPANY_FAIL';

export const CANCEL_REQUEST = 'CANCEL_REQUEST';
